/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';

import { UsersTenantResponseDto } from '../../models/users-tenant-response-dto';
import { UsersTenantUpdateDto } from '../../models/users-tenant-update-dto';

export interface TenantsControllerUpdate$Params {

/**
 * The ID of the tenant to update.
 */
  id: string;
      body: UsersTenantUpdateDto
}

export function tenantsControllerUpdate(http: HttpClient, rootUrl: string, params: TenantsControllerUpdate$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<UsersTenantResponseDto>> {
  const rb = new UsersRequestBuilder(rootUrl, tenantsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as UsersStrictHttpResponse<UsersTenantResponseDto>;
    })
  );
}

tenantsControllerUpdate.PATH = '/o2-users/tenants/{id}';
